'use client';

import { c as _c } from "react/compiler-runtime";
import { TOCItems, TOCProvider } from 'fumadocs-ui/components/layout/toc';
import { CalendarIcon, ListIcon } from 'lucide-react';
import { useTranslations } from 'next-intl';
import { MarkdownPreview } from '@/shared/blocks/common';
import { Crumb } from '@/shared/blocks/common/crumb';
import { type Post as PostType } from '@/shared/types/blocks/blog';
import { NavItem } from '@/shared/types/blocks/common';
import '@/config/style/docs.css';
export function BlogDetail(t0) {
  const $ = _c(56);
  const {
    post
  } = t0;
  const t = useTranslations("blog.page");
  let t1;
  if ($[0] !== t) {
    t1 = t("crumb");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = {
      title: t1,
      url: "/blog",
      icon: "Newspaper",
      is_active: false
    };
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = post.title || "";
  const t4 = `/blog/${post.slug}`;
  let t5;
  if ($[4] !== t3 || $[5] !== t4) {
    t5 = {
      title: t3,
      url: t4,
      is_active: true
    };
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t2 || $[8] !== t5) {
    t6 = [t2, t5];
    $[7] = t2;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const crumbItems = t6;
  const showToc = post.toc && post.toc.length > 0;
  const showAuthor = post.author_name || post.author_image || post.author_role;
  let t7;
  if ($[10] !== showAuthor || $[11] !== showToc) {
    t7 = () => {
      if (showToc && showAuthor) {
        return "lg:col-span-6";
      }
      if (showToc || showAuthor) {
        return "lg:col-span-9";
      }
      return "lg:col-span-12";
    };
    $[10] = showAuthor;
    $[11] = showToc;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  const getMainColSpan = t7;
  let t8;
  if ($[13] !== post.toc) {
    t8 = post.toc || [];
    $[13] = post.toc;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  const t9 = post.id;
  let t10;
  if ($[15] !== crumbItems) {
    t10 = <Crumb items={crumbItems} />;
    $[15] = crumbItems;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== post.title) {
    t11 = <h1 className="text-foreground mx-auto mb-4 w-full text-3xl font-bold md:max-w-4xl md:text-4xl">{post.title}</h1>;
    $[17] = post.title;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== post.created_at) {
    t12 = post.created_at && <div className="text-muted-foreground text-md mb-8 flex items-center justify-center gap-2"><CalendarIcon className="size-4" /> {post.created_at}</div>;
    $[19] = post.created_at;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== t12) {
    t13 = <div className="text-muted-foreground text-md mb-8 flex items-center justify-center gap-4">{t12}</div>;
    $[21] = t12;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== t11 || $[24] !== t13) {
    t14 = <div className="mt-16 text-center">{t11}{t13}</div>;
    $[23] = t11;
    $[24] = t13;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  let t15;
  if ($[26] !== showToc || $[27] !== t) {
    t15 = showToc && <div className="lg:col-span-3"><div className="sticky top-24 hidden md:block"><div className="bg-muted/30 rounded-lg p-4"><h2 className="text-foreground mb-4 flex items-center gap-2 font-semibold"><ListIcon className="size-4" /> {t("toc")}</h2><TOCItems /></div></div></div>;
    $[26] = showToc;
    $[27] = t;
    $[28] = t15;
  } else {
    t15 = $[28];
  }
  const t16 = getMainColSpan();
  let t17;
  if ($[29] !== post.body || $[30] !== post.content) {
    t17 = post.body ? <div className="docs text-foreground text-md space-y-4 font-normal *:leading-relaxed">{post.body}</div> : post.content && <div className="prose prose-lg text-muted-foreground max-w-none space-y-6 *:leading-relaxed"><MarkdownPreview content={post.content} /></div>;
    $[29] = post.body;
    $[30] = post.content;
    $[31] = t17;
  } else {
    t17 = $[31];
  }
  let t18;
  if ($[32] !== t17) {
    t18 = <article className="p-0">{t17}</article>;
    $[32] = t17;
    $[33] = t18;
  } else {
    t18 = $[33];
  }
  let t19;
  if ($[34] !== t16 || $[35] !== t18) {
    t19 = <div className={t16}>{t18}</div>;
    $[34] = t16;
    $[35] = t18;
    $[36] = t19;
  } else {
    t19 = $[36];
  }
  let t20;
  if ($[37] !== post.author_image || $[38] !== post.author_name || $[39] !== post.author_role || $[40] !== showAuthor) {
    t20 = showAuthor && <div className="lg:col-span-3"><div className="sticky top-24"><div className="bg-muted/30 rounded-lg p-6"><div className="text-center">{post.author_image && <div className="ring-foreground/10 mx-auto mb-4 aspect-square size-20 overflow-hidden rounded-xl border border-transparent shadow-md ring-1 shadow-black/15"><img src={post.author_image} alt={post.author_name} className="h-full w-full object-cover" /></div>}{post.author_name && <p className="text-foreground mb-1 text-lg font-semibold">{post.author_name}</p>}{post.author_role && <p className="text-muted-foreground mb-4 text-sm">{post.author_role}</p>}</div></div></div></div>;
    $[37] = post.author_image;
    $[38] = post.author_name;
    $[39] = post.author_role;
    $[40] = showAuthor;
    $[41] = t20;
  } else {
    t20 = $[41];
  }
  let t21;
  if ($[42] !== t15 || $[43] !== t19 || $[44] !== t20) {
    t21 = <div className="grid grid-cols-1 gap-8 md:mt-12 lg:grid-cols-12">{t15}{t19}{t20}</div>;
    $[42] = t15;
    $[43] = t19;
    $[44] = t20;
    $[45] = t21;
  } else {
    t21 = $[45];
  }
  let t22;
  if ($[46] !== t10 || $[47] !== t14 || $[48] !== t21) {
    t22 = <div className="py-24 md:py-32"><div className="mx-auto w-full max-w-7xl px-6 md:px-8">{t10}{t14}{t21}</div></div>;
    $[46] = t10;
    $[47] = t14;
    $[48] = t21;
    $[49] = t22;
  } else {
    t22 = $[49];
  }
  let t23;
  if ($[50] !== post.id || $[51] !== t22) {
    t23 = <section id={t9}>{t22}</section>;
    $[50] = post.id;
    $[51] = t22;
    $[52] = t23;
  } else {
    t23 = $[52];
  }
  let t24;
  if ($[53] !== t23 || $[54] !== t8) {
    t24 = <TOCProvider toc={t8}>{t23}</TOCProvider>;
    $[53] = t23;
    $[54] = t8;
    $[55] = t24;
  } else {
    t24 = $[55];
  }
  return t24;
}